// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"GT","skip_info":"HT","skipped":"IT","modify_order":"JT","cancel_subscription_btn":"KT","byb":"LT","modify_order_outer":"MT","byb_edit_btn":"NT","modify_order_item":"OT","cancel_copy_wrapper":"PT","cancelled_copy":"QT"};
    if(module.hot) {
      // 1713361653766
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  